import { Chip } from '@mui/material';

/*
  Marks the address a customer's messages default to.

  variant="soft" rather than a filled default Chip: the theme renders a filled default as
  near-black with white text (theme/overrides/components/chip.tsx), which reads as a status badge.
  This is a quiet annotation beside an address, so it wants the theme's grey pill.
*/
export function PreferredChip() {
  return (
    <Chip
      label="preferred"
      size="small"
      variant="soft"
      color="default"
      sx={{ height: 18, fontSize: 10, textTransform: 'lowercase' }}
    />
  );
}
